export default "__VITE_ASSET__BgaT3h7t__"